import React from 'react';
import { X, Copy, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { useApiKeys } from '../../../hooks';
import { useWorkbenchToast } from '../shared/toast';

export default function EmbedCodeModal({
  selectedLabel,
  embedLanguage,
  setEmbedLanguage,
  generateEmbedCode,
  onClose,
}) {
  const toast = useWorkbenchToast();
  const { data: keys } = useApiKeys();

  // Get the first active API key prefix for pre-fill
  const activeKey = keys?.find(k => k.is_active);
  const apiKeyPlaceholder = activeKey
    ? `${activeKey.key_prefix}...`
    : 'YOUR_API_KEY';
  const hasApiKey = !!activeKey;

  // Generate code with pre-filled API key if available
  const getCodeWithApiKey = (lang) => {
    const code = generateEmbedCode(lang);
    if (activeKey) {
      return code.replace(/YOUR_API_KEY/g, apiKeyPlaceholder);
    }
    return code;
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(getCodeWithApiKey(embedLanguage));
    toast.copied();
  };

  return (
    <div className="workbench-modal-overlay" onClick={onClose}>
      <div className="workbench-modal" onClick={e => e.stopPropagation()}>
        <div className="workbench-modal-header">
          <h2>Embed Code</h2>
          <button className="workbench-modal-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div className="workbench-modal-body">
          <p>Copy this code to integrate {selectedLabel} into your application:</p>

          <div className="embed-tabs">
            {['curl', 'javascript', 'python'].map(lang => (
              <button
                key={lang}
                className={`embed-tab ${embedLanguage === lang ? 'active' : ''}`}
                onClick={() => setEmbedLanguage(lang)}
              >
                {lang === 'curl' ? 'cURL' : lang === 'javascript' ? 'JavaScript' : 'Python'}
              </button>
            ))}
          </div>

          <div className="embed-code-container">
            <pre className="workbench-code-block">{getCodeWithApiKey(embedLanguage)}</pre>
            <button className="embed-copy-btn" onClick={handleCopy}>
              <Copy size={14} />
              Copy
            </button>
          </div>

          {hasApiKey ? (
            <div className="embed-note embed-note-success">
              <CheckCircle2 size={14} />
              <span>Using your API key: <code>{apiKeyPlaceholder}</code></span>
            </div>
          ) : (
            <div className="embed-note">
              <AlertTriangle size={14} />
              <span>Replace <code>YOUR_API_KEY</code> with your actual API key from the API Keys tab.</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
